import { useEffect, useState } from "react";
import useAuth from "../../../hook/useAuth";
import { getWorkOrder, put_UpdateWorkOrder } from "../../../services/WorkOrder";
import moment from "moment";
import { getStatus } from "../../../services/Appointment";
import { getStatusColor } from "../../../utils/functionHelper";
import { getUsers } from "../../../services/Users";
import { getPositions } from "../../../services/Tires";
import { getCustomerServices } from "../../../services/Services";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";


type WorkOrderProps = {
    primaryKey: null | number;
    setPleaseWaitPopup: (value: boolean) => void;
    status: string;
    appointmentWorkOrderId: null | number;
    updateAppointmentStatusWorkOrder: (value: string) => void;
    appointmentData: any
    allServices: any[]
}

export const WorkOrder = ({ primaryKey, setPleaseWaitPopup, status, appointmentWorkOrderId, updateAppointmentStatusWorkOrder, appointmentData, allServices }: WorkOrderProps) => {
    const { auth }: any = useAuth();
    const [allEmployee, setAllEmployee] = useState<any[]>([]);
    const [positions, setPositions] = useState<any[]>([]);
    const [servicesOptions, setServicesOptions] = useState<any[]>([]);
    const [empID, setEmpID] = useState<number>(0);
    const [empName, setEmpName] = useState<string>("");
    const [workOrderRefresh, setWorkOrderRefresh] = useState<boolean>(true);
    const [workOrderData, setWorkOrderData] = useState<any>(null);
    const [workOrderStatus, setWorkOrderStatus] = useState<any[]>([]);
    const [workOrderStatusName, setWorkOrderStatusName] = useState<string>("");
    const [workOrderId, setWorkOrderId] = useState<null | number>(null);
    const [workOrderCreatedAt, setWorkOrderCreatedAt] = useState<string | null>("");
    const [parkingCheckIn, setParkingCheckIn] = useState<string | null>("");
    const [parkingCheckOut, setParkingCheckOut] = useState<string | null>("");
    const [vehicleTag, setVehicleTag] = useState<string>("");
    const [assignToMe, setAssignToMe] = useState<string>("Yes")

    useEffect(() => {
        if (primaryKey && appointmentWorkOrderId) {
            setWorkOrderId(appointmentWorkOrderId)
            setWorkOrderRefresh(true)
        }
    }, [primaryKey, appointmentWorkOrderId])

    useEffect(() => {
        getPositions("TirePosition")
            .then((data) => {
                setPositions(data.reverse());
            }).catch((error) => {
                console.error(error);
                setPositions([]);
            })
    }, [])

    useEffect(() => {
        getCustomerServices()
            .then((data) => {
                setServicesOptions(data?.reverse())
            }).catch((error) => {
                setServicesOptions([]);
                console.error(error);
            })
    }, [])


    useEffect(() => {
        getStatus("WorkOrder")
            .then((data) => {
                setWorkOrderStatus(() => data?.map((status: any) => {
                    return {
                        id: status.statusID,
                        statusValue: status.statusValue
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])


    useEffect(() => {
        getUsers()
            .then((data) => {
                setAllEmployee(() => data?.map((item: any) => {
                    return {
                        value: item?.id,
                        label: `${item?.firstName} ${item?.lastName}`
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })

    }, [])

    useEffect(() => {
        if (primaryKey && primaryKey > 0 && workOrderId && workOrderId > 0 && workOrderRefresh) {
            setPleaseWaitPopup(true);
            getWorkOrder(primaryKey)
                .then((data) => {
                    setWorkOrderData(data[0]);
                    setWorkOrderStatusName(data[0]?.statusName);
                    setWorkOrderCreatedAt(data[0]?.createdAt);
                    setParkingCheckIn(data[0]?.parkingInSpot);
                    setParkingCheckOut(data[0]?.parkingOutSpot);
                    setEmpName(data[0]?.employeeName);
                    setVehicleTag(data[0]?.vehicleTag);
                    if (data[0]?.statusName === "InProgress" && data[0]?.employeeId > 0 && data[0]?.employeeId === Number(auth?.id)) {
                        setAssignToMe("Yes")
                    }
                    else if (data[0]?.statusName === "InProgress" && data[0]?.employeeId > 0 && data[0]?.employeeId !== Number(auth?.id)) {
                        setAssignToMe("No")
                    }
                    else {
                        setAssignToMe("Yes")
                    }
                    setPleaseWaitPopup(false);
                    setWorkOrderRefresh(false);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workOrderId, workOrderRefresh, auth])

    const handleOnInprogressUpdate = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (workOrderId && workOrderId > 0 && workOrderData) {
            setPleaseWaitPopup(true);
            put_UpdateWorkOrder({
                workOrderID: workOrderData?.workOrderID,
                appointmentID: workOrderData?.appointmentID,
                invoiceID: workOrderData?.invoiceID,
                customerID: workOrderData?.customerID,
                createdAt: workOrderData?.createdAt,
                parkingOutSpot: workOrderData?.parkingOutSpot,
                parkedOutAt: workOrderData?.parkedOutAt,
                lines: workOrderData?.lines,
                employeeId: assignToMe === "Yes" ? Number(auth?.id) : empID > 0 ? Number(empID) : null,
                statusId: assignToMe === "Yes" || empID > 0 ? workOrderStatus?.filter((s: any) => s?.statusValue === "InProgress")[0]?.id : workOrderData?.statusId,
                parkingInSpot: parkingCheckIn,
                vehicleTag: vehicleTag,
                parkedInAt: parkingCheckIn ? new Date().toLocaleString() : workOrderData?.parkedInAt,
            }, auth?.id)
                .then((res) => {
                    if (assignToMe === "Yes" || (assignToMe === "No" && empID > 0)) {
                        updateAppointmentStatusWorkOrder("inprogress");
                        setWorkOrderRefresh(true);
                    }
                    else {
                        updateAppointmentStatusWorkOrder("queued");
                        setWorkOrderRefresh(true);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }


    const handleOnDoneUpdate = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (workOrderId && workOrderId > 0 && workOrderData) {
            setPleaseWaitPopup(true);
            put_UpdateWorkOrder({
                workOrderID: workOrderData?.workOrderID,
                appointmentID: workOrderData?.appointmentID,
                invoiceID: workOrderData?.invoiceID,
                customerID: workOrderData?.customerID,
                createdAt: workOrderData?.createdAt,
                employeeId: assignToMe === "Yes" ? Number(auth?.id) : empID > 0 ? Number(empID) : null,
                vehicleTag: workOrderData?.vehicleTag,
                parkingInSpot: workOrderData?.parkingInSpot,
                parkedInAt: workOrderData?.parkedInAt,
                lines: workOrderData?.lines,
                statusId: parkingCheckOut === "" || parkingCheckOut === null ? workOrderData?.statusId : workOrderStatus?.filter((s: any) => s?.statusValue === "Done")[0]?.id,
                parkingOutSpot: parkingCheckOut,
                parkedOutAt: parkingCheckOut ? new Date().toLocaleString() : workOrderData?.parkedInAt
            }, auth?.id)
                .then((res) => {
                    if (parkingCheckOut !== "" && parkingCheckOut !== null) {
                        updateAppointmentStatusWorkOrder("done");
                        setWorkOrderRefresh(true);
                    }
                    else {
                        updateAppointmentStatusWorkOrder("inprogress");
                        setWorkOrderRefresh(true);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    return (
        <div className="w-full mt-2">
            <div className="mt-2 p-2">
                <div className="w-full mt-2">
                    <div className={`w-full pb-4`}>
                        {
                            (appointmentData?.status?.toLowerCase() === "queued" || appointmentData?.status?.toLowerCase() === "inprogress" || appointmentData?.status?.toLowerCase() === "done") && (
                                <div className="flex">
                                    <div className="mt-2 p-2 w-[50%]">

                                        <div>
                                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b pb-2">
                                                <div>
                                                    <span className="text-sm inline-block w-max font-semibold text-gray-800">
                                                        WorkOrder {workOrderId ? `#${workOrderId}` : ""}
                                                    </span>

                                                    {
                                                        workOrderCreatedAt && (
                                                            <p className="text-sm text-gray-500">
                                                                Date: {moment(new Date(workOrderCreatedAt?.split("T")[0])).format("dddd, MMM DD, YYYY")}
                                                            </p>
                                                        )
                                                    }
                                                </div>

                                                {workOrderStatusName && (() => {
                                                    const color = getStatusColor(workOrderStatusName);
                                                    return (
                                                        <span
                                                            className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}
                                                        >
                                                            {workOrderStatusName}
                                                        </span>
                                                    )
                                                })()}
                                            </div>
                                            {
                                                (workOrderId && workOrderId > 0 && (appointmentData?.status?.toLowerCase() === "inprogress" || appointmentData?.status?.toLowerCase() === "done")) && (
                                                    <div>
                                                        <div className="flex">
                                                            {(parkingCheckIn) && (
                                                                <div className="p-2 w-full">
                                                                    <h3 className="text-sm font-semibold text-gray-700 mb-2">
                                                                        Parking Check-In
                                                                    </h3>
                                                                    <div className="text-sm text-gray-600 space-y-1">
                                                                        <p className="font-medium text-gray-900">{parkingCheckIn}</p>

                                                                    </div>
                                                                </div>
                                                            )}

                                                            {(parkingCheckOut && appointmentData?.status?.toLowerCase() === "done") && (
                                                                <div className="p-2 w-full">
                                                                    <h3 className="text-sm font-semibold text-gray-700 mb-2">
                                                                        Parking Check-Out
                                                                    </h3>
                                                                    <div className="text-sm text-gray-600 space-y-1">
                                                                        <p className="font-medium text-gray-900">{parkingCheckOut}</p>

                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="flex">
                                                            {(vehicleTag) && (
                                                                <div className="p-2 w-full">
                                                                    <h3 className="text-sm font-semibold text-gray-700 mb-2">
                                                                        Vehicle Tag
                                                                    </h3>
                                                                    <div className="text-sm text-gray-600 space-y-1">
                                                                        <p className="font-medium text-gray-900">{vehicleTag}</p>

                                                                    </div>
                                                                </div>
                                                            )}

                                                            {(empName) && (
                                                                <div className="p-2 w-full">
                                                                    <h3 className="text-sm font-semibold text-gray-700 mb-2">
                                                                        Assigned To
                                                                    </h3>
                                                                    <div className="text-sm text-gray-600 space-y-1">
                                                                        <p className="font-medium text-gray-900">{empName}</p>

                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                    </div>
                                                )
                                            }


                                            {
                                                (workOrderId && workOrderId > 0 && appointmentData?.status?.toLowerCase() === "queued") && (
                                                    <>
                                                        <form className="py-2 w-full" onSubmit={handleOnInprogressUpdate}>
                                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
                                                                <div className="space-y-4">
                                                                    <div>
                                                                        <label className="block text-xs font-medium text-secondary">Parking Check-In</label>
                                                                        <input
                                                                            type="text"
                                                                            className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                                            value={parkingCheckIn ? parkingCheckIn : ""}
                                                                            placeholder="Parking Check-In"
                                                                            onChange={(e) => setParkingCheckIn(e.target.value)}
                                                                            required
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className={`block text-xs font-medium text-[#667085]`}>Assign To Me?</label>
                                                                        <RadioGroup
                                                                            row
                                                                            value={assignToMe}
                                                                            onChange={(e) => setAssignToMe(e.target.value)}
                                                                        >
                                                                            <FormControlLabel
                                                                                value="Yes"
                                                                                control={
                                                                                    <Radio
                                                                                        sx={{
                                                                                            color: "gray",
                                                                                            "&.Mui-checked": {
                                                                                                color: "blue",
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label="Yes"
                                                                                sx={{
                                                                                    color: "#2f3739",
                                                                                }}
                                                                            />

                                                                            <FormControlLabel
                                                                                value="No"
                                                                                control={
                                                                                    <Radio
                                                                                        sx={{
                                                                                            color: "gray",
                                                                                            "&.Mui-checked": {
                                                                                                color: "blue",
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label="No"
                                                                                sx={{
                                                                                    color: "#2f3739",
                                                                                }}
                                                                            />
                                                                        </RadioGroup>
                                                                    </div>

                                                                    {
                                                                        (assignToMe === "No") && (
                                                                            <div>
                                                                                <label className="block text-xs font-medium text-secondary">Assign To</label>
                                                                                <select
                                                                                    value={empID}
                                                                                    onChange={(e) => {
                                                                                        setEmpID(Number(e.target.value))
                                                                                    }}
                                                                                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm outline-none focus:border-primary bg-white"
                                                                                >
                                                                                    {
                                                                                        workOrderData?.statusName === "Queued" && (
                                                                                            <option value="">
                                                                                                Select
                                                                                            </option>
                                                                                        )
                                                                                    }

                                                                                    {allEmployee?.map((emp: any, index: number) => (
                                                                                        <option key={index} value={emp?.value}>
                                                                                            {emp?.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                                <div className="space-y-4">
                                                                    <div>
                                                                        <label className="block text-xs font-medium text-secondary">Vehicle Tag</label>
                                                                        <input
                                                                            type="text"
                                                                            className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                                            value={vehicleTag}
                                                                            placeholder="Vehicle Tag"
                                                                            onChange={(e) => setVehicleTag(e.target.value)}
                                                                            required
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <button type="submit" className="mt-4 border bg-primary hover:bg-white hover:border-primary hover:text-primary text-white text-sm p-2 rounded-md font-medium transition shadow-md">
                                                                Update
                                                            </button>


                                                        </form>
                                                    </>

                                                )
                                            }
                                            {
                                                (workOrderId != null && workOrderId > 0 && appointmentData?.status?.toLowerCase() === "inprogress") && (
                                                    <>
                                                        <form className="py-2 w-full" onSubmit={handleOnDoneUpdate}>
                                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
                                                                <div className="space-y-4">
                                                                    <div>
                                                                        <label className="block text-xs font-medium text-secondary">Parking Check-Out</label>
                                                                        <input
                                                                            type="text"
                                                                            className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                                            value={parkingCheckOut ? parkingCheckOut : ""}
                                                                            placeholder="Parking Check-Out"
                                                                            onChange={(e) => setParkingCheckOut(e.target.value)}

                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className={`block text-xs font-medium text-[#667085]`}>Assign To Me?</label>
                                                                        <RadioGroup
                                                                            row
                                                                            value={assignToMe}
                                                                            onChange={(e) => setAssignToMe(e.target.value)}
                                                                        >
                                                                            <FormControlLabel
                                                                                value="Yes"
                                                                                control={
                                                                                    <Radio
                                                                                        sx={{
                                                                                            color: "gray",
                                                                                            "&.Mui-checked": {
                                                                                                color: "blue",
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label="Yes"
                                                                                sx={{
                                                                                    color: "#2f3739",
                                                                                }}
                                                                            />

                                                                            <FormControlLabel
                                                                                value="No"
                                                                                control={
                                                                                    <Radio
                                                                                        sx={{
                                                                                            color: "gray",
                                                                                            "&.Mui-checked": {
                                                                                                color: "blue",
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label="No"
                                                                                sx={{
                                                                                    color: "#2f3739",
                                                                                }}
                                                                            />
                                                                        </RadioGroup>
                                                                    </div>

                                                                    {
                                                                        (assignToMe === "No") && (
                                                                            <div>
                                                                                <label className="block text-xs font-medium text-secondary">Assign To</label>
                                                                                <select
                                                                                    value={empID}
                                                                                    onChange={(e) => {
                                                                                        setEmpID(Number(e.target.value))
                                                                                    }}
                                                                                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm outline-none focus:border-primary bg-white"
                                                                                >
                                                                                    <option value="">
                                                                                        Select
                                                                                    </option>
                                                                                    {allEmployee?.map((emp: any, index: number) => (
                                                                                        <option key={index} value={emp?.value}>
                                                                                            {emp?.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                                <div className="space-y-4">
                                                                </div>
                                                            </div>
                                                            <button type="submit" className="mt-4 border bg-primary hover:bg-white hover:border-primary hover:text-primary text-white text-sm p-2 rounded-md font-medium transition shadow-md">
                                                                Update
                                                            </button>
                                                        </form>
                                                    </>

                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        {
                            (workOrderId && workOrderData?.lines?.length > 0) && (
                                <div className="flex">
                                    <div className="mt-2 p-2 w-[55%]">
                                        <div className="mt-4 border-b pb-2">
                                            <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                WorkOrder Details
                                            </h3>

                                            {workOrderData?.lines?.length > 0 ? (
                                                <div className="overflow-x-auto border rounded-lg">
                                                    <table className="w-full text-sm">
                                                        <thead className="bg-gray-50 text-gray-600">
                                                            <tr>
                                                                <th className="text-left px-4 py-3">Provided By Shop</th>
                                                                <th className="text-left px-4 py-3">Shelf</th>
                                                                <th className="text-left px-4 py-3">Rack</th>
                                                                <th className="text-right px-4 py-3">Position</th>
                                                                <th className="text-right px-4 py-3">Service</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {workOrderData?.lines.map((item: any, index: number) => (
                                                                <tr key={index} className="border-t">
                                                                    <td className="px-4 py-3">{item?.providedByShop ? "Yes" : "No"}</td>
                                                                    <td className="px-4 py-3">{item.shelf ? item.shelf : "--"}</td>
                                                                    <td className="px-4 py-3">{item.rackCode ? item.rackCode : "--"}</td>
                                                                    <td className="px-4 py-3 text-right">{positions?.filter((pos: any) => pos?.statusID === item?.position)[0]?.statusValue}</td>
                                                                    <td className="px-4 py-3 text-right">{servicesOptions?.filter((service: any) => service?.serviceID === item?.serviceID)[0]?.serviceName}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="text-sm text-gray-500 italic">
                                                    No invoice items available.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        {
                            appointmentData && (
                                <div className="flex">
                                    <div className="mt-2 p-2 w-[55%]">

                                        {
                                            (appointmentData?.vehicle && (appointmentData?.vehicle?.year > 0 && appointmentData?.vehicle?.make && appointmentData?.vehicle?.model)) && (
                                                <div className="mt-4 border-b pb-2">
                                                    <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                        Vehicle Details
                                                    </h3>
                                                    <div className="overflow-x-auto border rounded-lg">
                                                        <table className="w-full text-sm">
                                                            <thead className="bg-gray-50 text-gray-600">
                                                                <tr>
                                                                    <th className="text-left px-4 py-3">Year</th>
                                                                    <th className="text-left px-4 py-3">Make</th>
                                                                    <th className="text-right px-4 py-3">Model</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="border-t">
                                                                    <td className="px-4 py-3">{appointmentData?.vehicle?.year}</td>
                                                                    <td className="px-4 py-3">{appointmentData?.vehicle?.make}</td>
                                                                    <td className="px-4 py-3 text-right">{appointmentData?.vehicle?.model}</td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            )
                                        }

                                        {
                                            appointmentData?.vehicleTrim && (
                                                <div className="mt-4 border-b pb-2">
                                                    <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                        Trim Details
                                                    </h3>
                                                    <div>
                                                        {appointmentData?.vehicleTrim?.trimName}
                                                    </div>

                                                </div>
                                            )
                                        }

                                        {
                                            appointmentData?.service && (
                                                <div className="mt-4 border-b pb-2">
                                                    <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                        Service Details
                                                    </h3>
                                                    <div className="overflow-x-auto border rounded-lg">
                                                        <table className="w-full text-sm">
                                                            <thead className="bg-gray-50 text-gray-600">
                                                                <tr>
                                                                    <th className="text-left px-4 py-3">#</th>
                                                                    <th className="text-left px-4 py-3">Service</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="border-t">
                                                                    <td className="px-4 py-3">1</td>
                                                                    <td className="px-4 py-3">{appointmentData?.service?.serviceName}</td>
                                                                </tr>
                                                                {
                                                                    appointmentData?.additionalServices.length > 0 && (
                                                                        appointmentData?.additionalServices?.map((service: any, index: number) => (
                                                                            <tr key={index} className="border-t">
                                                                                <td className="px-4 py-3">{index + 2}</td>
                                                                                <td className="px-4 py-3">{service?.serviceName}</td>
                                                                            </tr>
                                                                        ))
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            )
                                        }

                                        {
                                            appointmentData?.tireFitment && (
                                                <div className="mt-4 border-b pb-2">
                                                    <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                        {appointmentData?.rearTireFitment ? "Front Tire Details" : "Tire Details"}
                                                    </h3>
                                                    <div className="overflow-x-auto border rounded-lg">
                                                        <table className="w-full text-sm">
                                                            <thead className="bg-gray-50 text-gray-600">
                                                                <tr>
                                                                    <th className="text-left px-4 py-3">Width</th>
                                                                    <th className="text-left px-4 py-3">Ratio</th>
                                                                    <th className="text-left px-4 py-3">Diameter</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="border-t">
                                                                    <td className="px-4 py-3">{appointmentData?.tireFitment?.metricWidth}</td>
                                                                    <td className="px-4 py-3">{appointmentData?.tireFitment?.aspectRatio}</td>
                                                                    <td className="px-4 py-3">{appointmentData?.tireFitment?.diameter}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            )
                                        }


                                        {
                                            appointmentData?.rearTireFitment && (
                                                <div className="mt-4 border-b pb-2">
                                                    <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                        Rear Tire Details
                                                    </h3>
                                                    <div className="overflow-x-auto border rounded-lg">
                                                        <table className="w-full text-sm">
                                                            <thead className="bg-gray-50 text-gray-600">
                                                                <tr>
                                                                    <th className="text-left px-4 py-3">Width</th>
                                                                    <th className="text-left px-4 py-3">Ratio</th>
                                                                    <th className="text-left px-4 py-3">Diameter</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="border-t">
                                                                    <td className="px-4 py-3">{appointmentData?.rearTireFitment?.metricWidth}</td>
                                                                    <td className="px-4 py-3">{appointmentData?.rearTireFitment?.aspectRatio}</td>
                                                                    <td className="px-4 py-3">{appointmentData?.rearTireFitment?.diameter}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            )
                                        }

                                        {
                                            allServices.length > 0 && (
                                                <div className="mt-4 border-b pb-2">
                                                    <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                        Tire Count
                                                    </h3>
                                                    <div className="overflow-x-auto border rounded-lg">
                                                        <table className="w-full text-sm">
                                                            <thead className="bg-gray-50 text-gray-600">
                                                                <tr>
                                                                    <th className="text-left px-4 py-3">Service Type</th>
                                                                    <th className="text-right px-4 py-3 ">Count</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {allServices.map((item: any, index: number) => (
                                                                    <tr key={index} className="border-t">
                                                                        <td className="px-4 py-3">{item.serviceName}</td>
                                                                        <td className="px-4 py-3 text-right">{item.quantity}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>



                                                </div>

                                            )
                                        }

                                        {
                                            appointmentData?.appointmentTireReservation?.length > 0 && (
                                                <div className="mt-4 border-b pb-2">
                                                    <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                        Tire Product Details
                                                    </h3>
                                                    <div className="overflow-x-auto border rounded-lg">
                                                        <table className="w-full text-sm">
                                                            <thead className="bg-gray-50 text-gray-600">
                                                                <tr>
                                                                    <th className="text-left px-4 py-3">Brand</th>
                                                                    <th className="text-left px-4 py-3">Model</th>
                                                                    <th className="text-left px-4 py-3">Quantity</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    appointmentData?.appointmentTireReservation?.map((product: any, index: number) => (
                                                                        <tr key={index} className="border-t">
                                                                            <td className="px-4 py-3">{product?.brandName}</td>
                                                                            <td className="px-4 py-3">{product?.modelName}</td>
                                                                            <td className="px-4 py-3">{product?.quantity}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            )
                                        }


                                        {
                                            appointmentData?.appointmentWheelReservation?.length > 0 && (
                                                <div className="mt-4 border-b pb-2">
                                                    <h3 className="text-sm font-semibold text-gray-700 mb-3">
                                                        Wheel Product Details
                                                    </h3>
                                                    <div className="overflow-x-auto border rounded-lg">
                                                        <table className="w-full text-sm">
                                                            <thead className="bg-gray-50 text-gray-600">
                                                                <tr>
                                                                    <th className="text-left px-4 py-3">Brand</th>
                                                                    <th className="text-left px-4 py-3">Model</th>
                                                                    <th className="text-left px-4 py-3">Quantity</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    appointmentData?.appointmentWheelReservation?.map((product: any, index: number) => (
                                                                        <tr key={index} className="border-t">
                                                                            <td className="px-4 py-3">{product?.brandName}</td>
                                                                            <td className="px-4 py-3">{product?.modelName}</td>
                                                                            <td className="px-4 py-3">{product?.quantity}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            )
                                        }

                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}